import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';
import Cookies from 'js-cookie';
import { $body, BrowserEvents, menuWrapper, MobileBreakpoint } from './constants';

//=================================
//	!---------- GLOBAL ----------
//=================================

// ---------- LazyLoad Config ----------

lazySizes.cfg.throttleDelay = 66;
lazySizes.cfg.preloadAfterLoad = true;

// ---------- jQuery Related ----------

;(function($) {

	$(document).on(BrowserEvents.barba.enter, function() {

		// ---------- Menu ----------

		const calculateMenuOffset = (target) => target.offset().top - ((window.innerWidth < MobileBreakpoint) ? 70 : 100);

		$('.menu-toggle').click(function(e) {
			e.preventDefault();

			if($body.hasClass('menu-open')) {
				$body.removeClass('menu-open');
				enableBodyScroll(menuWrapper);
			}
			else {
				$body.addClass('menu-open');
				disableBodyScroll(menuWrapper);
			}
		});

		// ---------- Links ----------

		$('a[href="#"], .void-link').click(function(e) {
			e.preventDefault();
		});

		$('[data-scroll-to]').click(function(e) {
			e.preventDefault();

			const self = $(this);
			const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

			if(target.length) {

				$('html, body').stop().animate({
					scrollTop: calculateMenuOffset(target)
				}, 1000);
			}
		});

		$('.select-dropdown .dropdown-menu a').click(function() {
			$(this).parents('.dropdown').find('.btn').html($(this).text());
		});

		// ---------- Inline SVGs ----------

		$('img.svg').inlineSvg();

		// ---------- LazyLoad ----------

		$(window).on(BrowserEvents.lazyload, function() {

			lazySizes.loader.checkElems();
			lazySizes.autoSizer.checkElems();

		});

		$(window).trigger(BrowserEvents.lazyload);

		// ---------- Disclaimer ----------

		$('.disclaimer-container').each(() => $body.addClass('disclaimer-open'));

		$('.close-disclaimer').click(function(e) {
			e.preventDefault();

			Cookies.set('tc-disclaimer', true, {
				expires: 365,
				path: '/',
			});

			$('#disclaimer').fadeOut(1000, function() {
				$(this).remove();
			});

			$body.removeClass('disclaimer-open');
		});

		$('#cookies-law').on('closed.bs.alert', function() {

			Cookies.set('tc-cookies', true, {
				expires: 365,
				path: '/',
			});

			$('.cookies-law').remove();
		});

		// ---------- Replace hover rules by active on touchscreens ----------

		if(!!('ontouchstart' in window) || !!('msmaxtouchpoints' in window.navigator)) {
			for(let sheetI = document.styleSheets.length - 1; sheetI >= 0; sheetI--) {
				const sheet = document.styleSheets[sheetI];
				if(sheet.cssRules) {
					for(let ruleI = sheet.cssRules.length - 1; ruleI >= 0; ruleI--) {
						const rule = sheet.cssRules[ruleI];
						if(rule.selectorText) {
							rule.selectorText = rule.selectorText.replace(':hover', ':active');
						}
					}
				}
			}
		}

		$(".single_variation_wrap").on("show_variation", function(event, variation) {

			if(variation.is_in_stock === false) {
				$('.woocommerce-variation-price').hide();
			}
			else {
				$('.woocommerce-variation-price').show();
			}
		});

		// ---------- Track calls ----------

		if(typeof gtag === 'function') {

			$('a[href^="tel"]').each(function() {
				$(this).on('click', () => gtag('event', 'appel', {
					'event_category': 'contact',
					'event_label': $(this).attr('href')
				}));
			});
		}
	});

}(jQuery));
